import PixPayment from './PixPayment.vue';

export default PixPayment;

